import { ErrorMessage, Field, FieldProps, useField } from "formik";
import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface TextareaInputProps {
    label: string;
    placeholder: string;
    name: string;
    id: string;
    isDisabled?: boolean;
}

const TextareaInput: React.FC<TextareaInputProps> = ({ label, placeholder, name, id, isDisabled }) => {
    const { t } = useTranslation();
    const [field, meta] = useField(name);
    const [charCount, setCharCount] = useState(0);

    useEffect(() => {
        setCharCount(field?.value?.length);
    }, [field.value]);

    return (
        <>
            <Col sm={3} md={2} className="mb-2 mb-sm-0">
                <label htmlFor={id} className="text-dark fs-7 fw-bold pt-3">
                    {label}
                </label>
            </Col>
            <Col sm={9} md={10}>
                <div className="position-relative">
                    <Field name={name}>
                        {({ field, meta, form }: FieldProps) => (
                            <textarea
                                {...field}
                                id={id}
                                placeholder={placeholder}
                                className={`form-control text-dark ${meta.touched && meta.error ? "is-invalid" : ""}`}
                                onBlur={() => form.setFieldTouched(field.name, true, true)}
                                maxLength={400}
                                disabled={isDisabled}
                            />
                        )}
                    </Field>
                    <ErrorMessage name="description">
                        {(msg) => <div className="invalid-feedback">{msg}</div>}
                    </ErrorMessage>
                </div>
                <span id="countSymbols" className="fs-7 lh-lg text-grey">
                    {charCount ? charCount : 0}/400
                </span>
                {meta.touched && meta.error && <div className="invalid-feedback">{meta.error}</div>}
            </Col>
        </>
    );
};

export default TextareaInput;
